import { render, staticRenderFns } from "./issue.vue?vue&type=template&id=34e09818&scoped=true&"
import script from "./issue.vue?vue&type=script&lang=js&"
export * from "./issue.vue?vue&type=script&lang=js&"
import style0 from "./issue.vue?vue&type=style&index=0&id=34e09818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e09818",
  null
  
)

export default component.exports